import { render, staticRenderFns } from "./HeaderLogin.vue?vue&type=template&id=be4526c2&scoped=true"
import script from "./HeaderLogin.vue?vue&type=script&lang=ts"
export * from "./HeaderLogin.vue?vue&type=script&lang=ts"
import style0 from "./HeaderLogin.vue?vue&type=style&index=0&id=be4526c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4526c2",
  null
  
)

export default component.exports